import * as React from "react"
import {
    Container,
    Stack,
    Flex,
    Heading,
    Text,
    useBreakpointValue,
} from '@chakra-ui/react';
import ImageGallery from 'react-image-gallery';
import truck_yellow_house from "../images/gallery/truck_yellow_house.jpg";
import clock from "../images/gallery/clock.jpg";
import loaded_truck from "../images/gallery/loaded_truck.jpg";
import loaded_truck2 from "../images/gallery/loaded_truck2.jpg";
import moving_dresser from "../images/gallery/moving_dresser.jpg";
import moving_table from "../images/gallery/moving_table.jpg";
import moving_furniture from "../images/gallery/moving_furniture.jpg";
import hot_tub_1 from "../images/gallery/hot_tub_1.jpg";
import hot_tub_2 from "../images/gallery/hot_tub_2.jpg";
import hot_tub_3 from "../images/gallery/hot_tub_3.jpg";
import hot_tub_4 from "../images/gallery/hot_tub_4.jpg";
import truck_grey_house from "../images/gallery/truck_grey_house.jpg";
import truck_white_house from "../images/gallery/truck_white_house.jpg";
import wrapped1 from "../images/gallery/wrapped1.jpg";
import front_house_1 from "../images/gallery/front_house_1.jpg";
import front_house_2 from "../images/gallery/front_house_2.jpg";
import outside_carry_steps from "../images/gallery/outside_carry_steps.jpg";

const importedImages = [truck_yellow_house, clock, loaded_truck, loaded_truck2, moving_dresser, moving_table, moving_furniture,
    hot_tub_1, hot_tub_2, hot_tub_3, hot_tub_4, truck_grey_house, truck_white_house, wrapped1, front_house_1, front_house_2,
    outside_carry_steps];
const images = importedImages.map(image => {
    return {
        original: image,
        thumbnail: image,
        loading: 'lazy',
        thumbnailLoading: 'lazy'
    };
});

export default function PhotoGallery() {

    const useVerticalGallery = useBreakpointValue({sm:'bottom', md: 'right'});

    return (
        <Stack direction={{base: 'column', lg: 'row'}} alignItems='center'>
            <Flex flexGrow={1} flexBasis={'fit-content'}>
                <Container maxW={{base: "100vw", md: "636px"}}>
                    <ImageGallery
                        items={images}
                        showPlayButton={false}
                        showFullscreenButton={false}
                        showBullets={true}
                        showIndex={true}
                        slideDuration={0}
                        thumbnailPosition={useVerticalGallery}
                        lazyLoad={true}
                    />
                </Container>
            </Flex>
            <Flex flexGrow={1} flexBasis={'fit-content'} pt={{base: 30, lg: 0}}>
                <Stack direction='column' maxW={"600px"}>
                    <Heading>Jameson Moving & Storage Photo Gallery</Heading>
                    <Text className="subTitle" fontSize={{ base: 'lg', lg: 'xl' }}>Whether it's just a single antique item or an entire 4,000 sq. foot home, our team has the knowledge, skills and equipment to make your move a smooth, stress-free experience.</Text>
                </Stack>
            </Flex>
        </Stack>
    );
}